/* eslint-disable rover/no-platform-specific-globals-or-imports */

declare let window: Window & typeof globalThis & { __SERVER_PATH__: string };

function getServerUrl(): URL {
  return new URL(window.__SERVER_PATH__, document.URL); // eslint-disable-line no-underscore-dangle
}

// We already have the correct urls server-side because of cloudflare normalization rules.
// https://developers.cloudflare.com/rules/normalization/how-it-works/#cloudflare-normalization
// Here we're matching the url client-side with what the server received.
export function matchServerSidePath(): void {
  const { pathname: serverPath } = getServerUrl();
  const clientUrl = new URL(window.location.href);

  if (clientUrl.pathname !== serverPath) {
    clientUrl.pathname = serverPath;
    window.history.replaceState(window.history.state, '', clientUrl);
  }
}
